// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Zy-z","tooltipWrapper":"_y-z","icon":"az-z","tooltip":"bz-z","content":"cz-z"};